import { NonUserEmails } from '../../../cimsPage/instances/admin'
import { CreateViewEditRemove } from '../../common'

const nonUserEmails = CreateViewEditRemove({
  page: NonUserEmails,
  object: 'Non User Email',
  create: '89d075ef-89d1-44da-8518-3f4d6252047c',
  view: 'eeb94bd7-83dd-47c8-964f-dda0b6fe27f9',
  edit: 'ebebe8f1-c3f5-4b95-97f4-e064bd2a35ae',
  remove: '983bdf94-8938-463f-b755-cb24737533d8',
})

export const CreateNonUserEmail = nonUserEmails.Create
export const ViewNonUserEmail = nonUserEmails.View
export const EditNonUserEmail = nonUserEmails.Edit
export const RemoveNonUserEmail = nonUserEmails.Remove

export type NonUserEmailPermission =
  | typeof CreateNonUserEmail
  | typeof ViewNonUserEmail
  | typeof EditNonUserEmail
  | typeof RemoveNonUserEmail
